// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"style_mainSection__Xn6Wh"};